"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
var socket_io_client_1 = require("socket.io-client");
var shared_1 = require("@technis/shared");
var env_1 = require("../config/env");
var RECONNECTION_DELAY = shared_1.MINUTE_IN_MILLISECONDS * 5;
var RECONNECTION_ATTEMPTS = 2;
var DELAY_CONNECT_WS = 1000 * 5; // 5 seconds
/**
 * We will expose a tracker class to frontend library
 */
var Tracker = /** @class */ (function () {
    /**
     * constructor to initialize the socket connection
     * @param {TrackingConnection} connectionPayload
     */
    function Tracker(connectionPayload) {
        var _this = this;
        this.initWSConnection = function () {
            var isDev = _this.trackingConnection.isDev;
            return new Promise(function (resolve) {
                var socketClient = (0, socket_io_client_1.io)(isDev ? env_1.config.trackingBackendUrlDev : env_1.config.trackingBackendUrl, {
                    reconnectionAttempts: RECONNECTION_ATTEMPTS,
                    reconnectionDelay: RECONNECTION_DELAY,
                    timeout: DELAY_CONNECT_WS,
                    transports: ["websocket"],
                });
                socketClient.on("connect_error", function (error) {
                    _this.socket = undefined;
                    console.log("connect_error due to ".concat(error.message));
                    resolve(false);
                });
                socketClient.on("connect", function () {
                    console.log("Connection to socket server successful");
                    _this.socket = socketClient;
                    _this.socket.emit(shared_1.TrackingSocketEvents.CONNECT, _this.trackingConnection);
                    resolve(true);
                });
            });
        };
        this.extendPayload = function (payload) { return (__assign(__assign({}, payload), { projectId: _this.trackingConnection.projectId })); };
        this.trackingConnection = connectionPayload;
    }
    /**
     * set the user id to session
     * @param {object} payload
     */
    Tracker.prototype.setUser = function (payload) {
        if (!this.socket) {
            throw new Error(shared_1.TrackingErrors.SOCKET_NOT_INITIALIZED);
        }
        this.socket.emit(shared_1.TrackingSocketEvents.SET_USER, payload);
    };
    /**
     * set the user id to session
     * @param {object} payload
     */
    Tracker.prototype.setLanguage = function (payload) {
        if (!this.socket) {
            throw new Error(shared_1.TrackingErrors.SOCKET_NOT_INITIALIZED);
        }
        this.socket.emit(shared_1.TrackingSocketEvents.SET_LANGUAGE, payload);
    };
    /**
     * save action
     * @param {TrackingAction} payload
     */
    Tracker.prototype.saveAction = function (payload) {
        if (!this.socket) {
            throw new Error(shared_1.TrackingErrors.SOCKET_NOT_INITIALIZED);
        }
        this.socket.emit(shared_1.TrackingSocketEvents.LOG_ACTION, this.extendPayload(payload));
    };
    /**
     * save Error
     * @param {TrackingError} payload
     */
    Tracker.prototype.saveError = function (payload) {
        if (!this.socket) {
            throw new Error(shared_1.TrackingErrors.SOCKET_NOT_INITIALIZED);
        }
        this.socket.emit(shared_1.TrackingSocketEvents.LOG_ERROR, this.extendPayload(payload));
    };
    /**
     * save View Activity
     * @param {object} payload
     */
    Tracker.prototype.saveViewActivity = function (payload) {
        if (!this.socket) {
            throw new Error(shared_1.TrackingErrors.SOCKET_NOT_INITIALIZED);
        }
        this.socket.emit(shared_1.TrackingSocketEvents.LOG_VIEW_ACTIVITY, payload);
    };
    /**
     * Close the websocket communication
     */
    Tracker.prototype.endConnection = function () {
        if (!this.socket) {
            throw new Error(shared_1.TrackingErrors.SOCKET_NOT_INITIALIZED);
        }
        this.socket.emit(shared_1.TrackingSocketEvents.END_CONNECTION);
    };
    return Tracker;
}());
exports.Tracker = Tracker;
